export default "__VITE_ASSET__80eee322__"